import { rm } from "./lib/fsLimit.js";
const deleteProjectFile = async (args) => {
  const filePath = args.helpers.joinPathFromRoot(args.filename);
  await rm(filePath, { recursive: true });
  return filePath;
};
export {
  deleteProjectFile
};
//# sourceMappingURL=deleteProjectFile.js.map
